import JobTitles from '@/views/job-titles/job-titles-list.vue'
import AddJobTitle from '@/views/job-titles/job-titles-new.vue'
import EditJobTitle from '@/views/job-titles/job-titles-edit.vue'
import { JobTitlesRouteNames } from '@/router/routes-names'

export const jobTitlesRoutes = [
    {
        path: '/job-titles/',
        name: JobTitlesRouteNames.LIST,
        component: JobTitles
    },
    {
        path: '/job-titles/new',
        name: JobTitlesRouteNames.NEW,
        component: AddJobTitle
    },
    {
        path: '/job-titles/edit/:id',
        name: JobTitlesRouteNames.EDIT,
        component: EditJobTitle
    }
]
